import { getCategoryIDFromSlug } from './categoriesPathSegment';
import { suffixCategoriesRegexp } from './constants';

const createSinglePathSegment = (pathname: string, segment: string): string | number => {
  switch (segment) {
    case 'tags': {
      const tagsRegexp = new RegExp(suffixCategoriesRegexp.tags.codename);
      return tagsRegexp.test(pathname) ? (pathname?.match(suffixCategoriesRegexp.tags.codename)?.[0] ?? '') : '';
    }

    case 'category': {
      const categoryID = getCategoryIDFromSlug(pathname);
      return categoryID;
    }
    case 'page':
      return pathname?.lastIndexOf(suffixCategoriesRegexp.page.codename) !== -1
        ? pathname?.slice(
            pathname.lastIndexOf(suffixCategoriesRegexp.page.codename) + suffixCategoriesRegexp.page.codename.length,
          )
        : '';
    default:
      return '';
  }
};

export default createSinglePathSegment;
